import { ExitToApp, Home, Settings, Info, AccountCircle, Security } from "@mui/icons-material";
import { link } from "d3";

export const menuConfig = {
    header: {
        environment: "PROD",
        profileName: "JOHN DOE",
        profileEmail: "johndoe@example.com",
        logoutButton: {
            text: "Logout",
            icon: ExitToApp,
        },
    },
    mainMenu: [
        {
            text: "ADMIN",
            role: "admin",
            disabled: false,
            link: "/admin",
        },
        {
            text: "DOCUMENTATION",
            role: "admin",
            disabled: false,
            subMenu: [
                { text: "Release Notes", icon: AccountCircle, disabled: false, link: "/releases" },
                { text: "Feature Roadmap", icon: Security, disabled: false, link: "/roadmap" },
            ]
        },
        {
            text: "CHAT HISTORY",
            role: "user",
            disabled: true
        },
    ],
    footer: {
        supportText: "Support: support@racklet.ai",
    },
};